import { defineComponent as _defineComponent } from 'vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from '@@/library/v4/components/OzTextButton.vue'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostAttachmentEmbedControl',
  props: {
    colorScheme: null,
    isDownloadable: { type: Boolean },
    downloadUrl: null,
    dir: null
  },
  emits: ['back-to-preview', 'expand', 'open-in-new'],
  setup(__props: any) {

const props = __props as {
  colorScheme: 'light' | 'dark'
  isDownloadable: boolean
  downloadUrl: string
  dir: string
}





const vEmitClickOnTouch = emitClickOnTouch

const isDarkColorScheme = computed<boolean>(() => props.colorScheme === 'dark')

return { __sfc: true,props, vEmitClickOnTouch, isDarkColorScheme, OzIcon, OzTextButton, OzTextButtonColorScheme }
}

})